/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Provider_TimeoutInputs */

const vi_einvoice_error_provider_timeout = /** @type {(inputs: Einvoice_Error_Provider_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA đang phản hồi chậm nên chưa kiểm tra được hóa đơn. Vui lòng thử lại sau ít phút; không phát hành lại hóa đơn.`)
};

/**

* @param {Einvoice_Error_Provider_TimeoutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_provider_timeout = /** @type {((inputs?: Einvoice_Error_Provider_TimeoutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Provider_TimeoutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_provider_timeout(inputs)
});